export const blockIconsMapsCrisisAlertNew = (
	<span className='material-symbols-outlined'>crisis_alert</span>
);
